<script setup lang="ts">
const props = defineProps<{
  faq: {
    title: string;
    subtitle: string;
    list: Record<
      string,
      {
        question: string;
        answer: string;
        icon: string;
        moreText: string;
      }
    >;
  };
  themeKeys: {
    bg: string;
    fg: string;
    unselectedBg: string;
    selectedBg: string;
    selectedFg: string;
  };
}>();
</script>

<template>
  <div
    class="outer-p-container transition duration-500"
    :style="{
      backgroundColor: props.themeKeys.bg,
    }"
  >
    <div class="inner-container p-12">
      <div class="w-fit mx-auto">
        <h2
          class="font-semibold text-5xl mb-5 text-center"
          :style="{
            color: props.themeKeys.title,
          }"
        >
          {{ props.faq.title }}
        </h2>
        <p
          class="text-lg"
          :style="{
            color: props.themeKeys.subtitle,
          }"
        >
          {{ props.faq.subtitle }}
        </p>
      </div>
      <div
        class="
          flex flex-row flex-wrap justify-evenly
          px-6 lg:pl-18 lg:pr-6 pt-12 gap-8
          *:w-2/5 *:min-w-96
        "
      >
        <div
          v-for="item in Object.values(props.faq.list)"
          class="flex flex-row gap-4"
        >
          <div
            class="p-3 rounded-full aspect-square size-12"
            :style="{
              color: props.themeKeys.iconFg,
              backgroundColor: props.themeKeys.iconBg,
            }"
          >
            <Icon
              :name="`i-lucide-${item.icon}`"
              class="size-6"
            />
          </div>
          <UCollapsible>
            <button
              class="cursor-pointer flex flex-row gap-2 group mt-2 text-start"
            >
              <h3
                class="font-semibold text-xl mb-1"
                :style="{
                  color: props.themeKeys.question,
                }"
              >
                {{ item.question }}
              </h3>
              <UIcon
                name="i-lucide-chevron-down"
                class="mt-0.5 size-5 sm:size-6 text-gray-500 group-data-[state=open]:rotate-90 transition-transform duration-300 shrink-0"
                :style="{
                  color: props.themeKeys.question,
                }"
              />
            </button>
            <template #content>
              <p
                class="mb-2"
                :style="{
                  color: props.themeKeys.answer,
                }"
              >
                {{ item.answer }}
              </p>
            </template>
          </UCollapsible>
        </div>
      </div>
    </div>
  </div>
</template>
